import React, { Component } from 'react';
import ReactLoading from 'react-loading';

export default class ButtonLoader extends Component {
  render () {
    return (<ReactLoading className="button-loader" type="spinningBubbles" color="white" height={25} width={25} />);
  }
}